export default __webpack_public_path__ + "static/media/man.bf3ec45d.png";